import { addressSchema } from '@nodal/core/consts/addressSchema';
import { t } from '@nodal/i18n';
import * as Yup from 'yup';

export const surrogateValidationSchema = Yup.object({
  first_name: Yup.string().nullable().required(t('This field is required')),
  middle_name: Yup.string().nullable(),
  last_name: Yup.string().nullable().required(t('This field is required')),
  maiden_name: Yup.string().nullable().optional(),
  date_of_birth: Yup.string().nullable().required(t('This field is required')),
  phone_number: Yup.number().nullable().required(t('This field is required')),
  address: addressSchema.required(),
  same_mailing_address: Yup.boolean().nullable(),
  mailing_address: Yup.object().when('same_mailing_address', {
    is: false,
    then: () => addressSchema.required(),
    otherwise: () => Yup.object().nullable(),
  }),
});
